import { FC, useState, useEffect } from 'react'

import { AxiosResponse } from 'axios'
import { Tab } from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useLoading, useModal } from 'hooks'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import {
  ContractNGTServices,
  //IAggregatedContratos,
  ICentroPlanta,
  IGrupoMercadoriaResponse,
  IHierarquiaProdutoResponse
} from 'services/NGT/Contract'
import {
  ISectorParams,
  SectorParamsServices
} from 'services/NGT/ContractsParams'
import { CostCenterServices } from 'services/NGT/CostCenter'
import {
  managementUnitService,
  creService
} from 'services/NGT/Parameterization'

import { AddNewContract } from './components/AddNewContract/AddNewContract'
import Contrato from './components/Contrato'
import { EditNoSapContract } from './components/EditNoSapContract/EditNoSapContract'
import SearchSupplierContracts from './components/SearchSupplierContracts/SearchSupplierContracts'
import { ViewContract } from './components/ViewContract/ViewContract'


const Contracts: FC = () => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()
  const [tipoCre, setTipoCre] = useState([])
  const [unidadeGestora, setUnidadeGestora] = useState([])
  const [setores, setSetores] = useState<ISectorParams[]>([])
  const [grpMercadorias, setGrpMercadorias] = useState<
    IGrupoMercadoriaResponse[]
  >([])
  const [hierarquiaProdutos, setHierarquiaProdutos] = useState<
    IHierarquiaProdutoResponse[]
  >([])
  const [tabs, setTabs] = useState<string[]>(['Pesquisar', 'Adicionar Novo'])
  const [contractID, setContractID] = useState<string>('')
  const [costCenters, setCostCenter] = useState<ICentroPlanta[]>([])
  const [selectedTab, setSelectedTab] = useState(0)
  const [isSuccess, toggleSucessModal] = useToggle()
  const [isError, toggleErrorModal] = useToggle()
  const [errorSubstituto, setErrorSubstituto] = useState(false)
  const [messageError, setMessageError] = useState('')
  const [flPrincipal, setFlprincipal] = useState(false)
  const [flSap, setFlSap] = useState(false)
  const [dtCadastro, setDtcadastro] = useState(new Date())
  const handleChange = (_, newValue) => setSelectedTab(newValue)
  const [toggleToClear, setToggleToClear] = useState<boolean>(false)

  useEffect(() => {
    if (toggleToClear) {
      setSelectedTab((tab) => tab - 1)
      setToggleToClear(false)
      setTimeout(() => {
        setSelectedTab((tab) => tab + 1)
      }, 30)
    }
  }, [toggleToClear])

  function handleSubmitForm(data) {
    const contraparteSubstituto = []

    Object.keys(data).filter((key) => {
      if (/idSubstituto.*/g.test(key)) {
        const value = data[key]

        if (contraparteSubstituto.includes(data[key])) {
          setErrorSubstituto(true)
        } else {
          contraparteSubstituto.push(value)
        }
      }
    })

    if (errorSubstituto) {
      setMessageError('não pode ter o mesmo usuario como dois substitutos')
      toggleErrorModal()
      setErrorSubstituto(false)
      return
    }

    if (
      contraparteSubstituto.includes(data.idComprador) ||
      contraparteSubstituto.includes(data.idContraparte) ||
      data.idComprador == data.idContraparte
    ) {
      setMessageError('usuários iguais para funções diferentes')
      toggleErrorModal()
      return
    }

    const obj = {
      cdContrato: data.contrato || '',
      cdGrupoMercadoria: data.codGrupoMercadoria || '',
      cdHierarquiaProd: data.codHierarquiaProduto || '',
      centroCustoId: data.centroSelecionado || 0,
      compradorUsuarioId: data.idComprador || 0,
      contraparteUsuarioId: data.idContraparte || 0,
      contraparteUsuarioSubstitutoId: contraparteSubstituto || [],
      contratoPrincipalId: data.contratoPrincipalId || 0,
      dtVigFimReal: moment(data.fimVigenciaReal).toDate(),
      dtVigInicoReal: moment(data.inicioVigenciaReal).toDate(),
      dtVigenciaFim: moment(data.fimVigencia).toDate(),
      dtVigenciaInicio: moment(data.inicioVigencia).toDate(),
      empresaId: data.empresa || 0,
      flEncerrado: data.flEncerrado || false,
      flRecorrente: data.flRecorrente || false,
      flSocio: data.flSocio || false,
      flSubcontrato: data.flSubcontrato || false,
      fornecedorId: data.fornecedor || 0,
      setorId: parseInt(data.setor) || 0,
      txCno: data.cno || '',
      txObjetoContrato: data.objetoContrato || '',
      vlContratual: parseInt(data.valorContratual || null)
    }

    ContractNGTServices()
      .create(obj)
      .then(() => {
        toggleSucessModal()
      })
      .catch(() => {
        // setMessageError('não foi possível cadastrar o usuário')
        setLoading("idle")
        showModal({
          hideButtonCancel: true,
          message: 'não foi possível cadastrar o usuário',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        toggleErrorModal()
      })
  }

  // *** Código abaixo foi comentado devido a não implementação das rotas agregadas ***
  // const getInitialData = () => {
  //   ContractNGTServices()
  //     .aggregatedContratos()
  //     .then((response: AxiosResponse<IAggregatedContratos>) => {
  //       setUnidadeGestora(response.data.contrato_unidadeGestora)
  //       setSetores(response.data.contrato_setorContrato)
  //       setCostCenter(response.data.contrato_centroPlanta.entity)
  //       setGrpMercadorias(response.data.contrato_gruposMercadoriaSap)
  //       setTipoCre(response.data.contrato_tipoCre)
  //       setHierarquiaProdutos(response.data.contrato_hierarquiaProdutoSap)
  //     })
  // }

  const getManagementUnit = () => {
    managementUnitService()
      .getAll()
      .then(({ data }) => {
        setUnidadeGestora(data)
      })
  }

  const getSectors = () => {
    SectorParamsServices()
      .getAll()
      .then(({ data }) => {
        setSetores(data)
      })
  }

  const getCostCenter = () => {
    CostCenterServices()
      .allCostCenter()
      .then(({ data }) => {
        setCostCenter(data.entity)
      })
  }

  const getTipoCre = () => {
    creService()
      .getAll()
      .then(({ data }) => {
        setTipoCre(data)
      })
  }

  const getGrpMercadoria = () => {
    ContractNGTServices()
      .getAllGrpMercadoria()
      .then(({ data }) => {
        setGrpMercadorias(data.entity)
      })
  }

  const getHierarquiaProduto = () => {
    ContractNGTServices()
      .getAllHierarquiaProduto()
      .then(({ data }) => {
        setHierarquiaProdutos(data.entity)
      })
  }

  const addNewTab = (tabName: string) => {
    setTabs((prevTabs) => [...prevTabs, tabName])
  }

  const handleClickContract = ({
    contratoId,
    cdContrato,
    dtCadastro,
    flSap
  }) => {
    if (tabs.length == 3) {
      setTabs(['Pesquisar', 'Adicionar Novo'])
    }

    setFlSap(flSap)
    setDtcadastro(dtCadastro)
    setContractID(contratoId)
    addNewTab(cdContrato)
    setSelectedTab(2)
  }

  useEffect(() => {
    //getInitialData()
    getCostCenter()
    getSectors()
    getManagementUnit()
    getTipoCre()
    getGrpMercadoria()
    getHierarquiaProduto()
  }, [])

  return (
    <>
      <Tab tabs={tabs} key={'selectedTabs'} value={selectedTab} handleChange={handleChange} />

      {selectedTab === 0 && (
        <SearchSupplierContracts key={0} handleClickContract={handleClickContract} />
      )}

      {selectedTab === 1 && (
        <AddNewContract
          setTab={setSelectedTab}
          flPrincipal={flPrincipal}
          key={1}
          tipoCre={tipoCre}
          unidadesGestoras={unidadeGestora}
          sectors={setores}
          costCenters={costCenters}
          grpMercadorias={grpMercadorias}
          hierarquiaProdutos={hierarquiaProdutos}
          setToggleToClear={setToggleToClear}
        />
      )}

      {/* {selectedTab === 3 && ( */}
      {/*   <Contrato /> */}
      {/* )} */}

      {selectedTab === 2 &&
        (flSap ? (
          <ViewContract
            setTab={setSelectedTab}
            dtCadastro={dtCadastro}
            flPrincipal={flPrincipal}
            flSap={flSap}
            tipoCre={tipoCre}
            key={2}
            unidadesGestoras={unidadeGestora}
            sectors={setores}
            costCenters={costCenters}
            contractID={contractID}
          />
        ) : (
          <EditNoSapContract
            setTab={setSelectedTab}
            dtCadastro={dtCadastro}
            flPrincipal={flPrincipal}
            flSap={flSap}
            key={2}
            tipoCre={tipoCre}
            unidadesGestoras={unidadeGestora}
            sectors={setores}
            costCenters={costCenters}
            contractID={Number(contractID)}
            grpMercadorias={grpMercadorias}
            hierarquiaProdutos={hierarquiaProdutos}
          />
        ))}

      <SuccessModal
        message="Contrato Criado com sucesso"
        open={isSuccess}
        type="sucess"
        handleConfirm={toggleSucessModal}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={messageError}
        open={isError}
        type="error"
        handleConfirm={toggleErrorModal}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}

export default Contracts
